import React, { useEffect, useState } from "react";
import { Play, Square } from "lucide-react";
import { Button } from "@/components/ui/button";

const pickVoice = () => {
  const voices = window.speechSynthesis?.getVoices?.() || [];
  return (
    voices.find((v) => v.lang?.toLowerCase().startsWith("es-mx")) ||
    voices.find((v) => v.lang?.toLowerCase().startsWith("es")) ||
    null
  );
};

export const VoiceScriptPlayer = ({ script, label = "Escuchar el guion", testId }) => {
  const [playing, setPlaying] = useState(false);

  useEffect(() => () => window.speechSynthesis?.cancel(), []);

  const toggle = () => {
    if (!window.speechSynthesis || !script) return;
    if (playing) {
      window.speechSynthesis.cancel();
      setPlaying(false);
      return;
    }
    const utter = new window.SpeechSynthesisUtterance(script);
    utter.lang = "es-MX";
    utter.rate = 0.85;
    const voice = pickVoice();
    if (voice) utter.voice = voice;
    utter.onend = () => setPlaying(false);
    utter.onerror = () => setPlaying(false);
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(utter);
    setPlaying(true);
  };

  if (!script) return null;

  return (
    <Button
      variant="outline"
      size="sm"
      data-testid={testId || "voice-script-play"}
      onClick={toggle}
      className="h-7 border-brand bg-brand-soft text-[11.5px] text-brand hover:opacity-80"
    >
      {playing ? <Square className="mr-1.5 h-3 w-3" /> : <Play className="mr-1.5 h-3 w-3" />}
      {label}
    </Button>
  );
};
